import { MooringDepartureLineHandling } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const MOORING_DEPARTURE_LINE_HANDLING_DATA_TAG = 'MooringDepartureLineHandling';
export default class MooringDepartureLineHandlingParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.MOORING_DEPARTURE_LINE_HANDLING, FIXED_PROTOCOL_CONTENT_TYPE_IDS.MOORING_DEPARTURE_LINE_HANDLING, MOORING_DEPARTURE_LINE_HANDLING_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            port: 'port',
            type: 'type',
            freeText: 'freeText',
        };
    }
    createData(props, record) {
        const data = new MooringDepartureLineHandling(props.port, props.type, props.freeText);
        const linked = this.getLinked(record);
        if (linked) {
            const link = {
                protocol: linked,
                value: props.port,
            };
            data.port = link;
        }
        return data;
    }
}
//# sourceMappingURL=MooringDepartureLineHandlingParser.js.map